import { ActivityIndicator, StyleSheet, TouchableOpacity, View } from "react-native";
import React, { useEffect, useState } from "react";
import Svg, { Circle, G, Mask, Path, Rect } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { router, useLocalSearchParams } from "expo-router";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import { Colors } from "colors";
import { FONTS_SIZES } from "fonts";
import ImageView from "../src/image";
import { Images } from "assets";
import ListView from "components/ListView";
import OrderStatusCard from "components/checkout/OrderStatusCard";
import { PAYMENT_STATUS_CODE } from "utils/Constants";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import { getOrderDetails } from "appRedux/reducers/orderSlice";
import { trackV2 } from "utils/Segment";

const OrderStatus = ({}) => {
    const [orderDetails, setOrderDetails] = useState();
    const [loading, setLoading] = useState(false);
    const [orderProductList, setOrderProductList] = useState([]);
    const local = useLocalSearchParams();
    const gender = local?.gender || "female";
    const orderId = useLocalSearchParams()?.id || null;

    const ORDER_STATUS_MAP = {
        [PAYMENT_STATUS_CODE.pending]: {
            bgColor: "#F7F7F7",
            icon: () => (
                <Svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <G id="Group 3">
                        <Circle
                            id="Oval"
                            cx="12.97"
                            cy="12.0299"
                            r="12"
                            transform="rotate(0.143023 12.97 12.0299)"
                            fill="#212427"
                        />
                        <Path
                            id="Union"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.3306 17.1808C18.5976 16.8641 18.5574 16.3909 18.2407 16.1239L12.8122 11.5462L13.4284 6.62662C13.4799 6.21561 13.1884 5.84069 12.7774 5.78921C12.3664 5.73773 11.9915 6.02917 11.94 6.44017L11.2875 11.6495C11.2832 11.6841 11.2812 11.7185 11.2817 11.7525C11.2451 12.0009 11.3341 12.2619 11.5402 12.4357L17.2737 17.2706C17.5904 17.5376 18.0635 17.4974 18.3306 17.1808Z"
                            fill="white"
                        />
                    </G>
                </Svg>
            ),
            label: "Payment pending from Bank",
            description: "Once we receive this payment, we will place this order.",
        },
        [PAYMENT_STATUS_CODE.failed]: {
            bgColor: "#F7F7F7",
            icon: () => (
                <Svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <G id="Group 3">
                        <Circle
                            id="Oval"
                            cx="12.97"
                            cy="12.0299"
                            r="12"
                            transform="rotate(0.143023 12.97 12.0299)"
                            fill="#F5513C"
                        />
                        <Path
                            id="Union"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.1518 5.25C12.6192 5.25 12.1875 5.68172 12.1875 6.21429L12.1875 14.4107C12.1875 14.9433 12.6192 15.375 13.1518 15.375C13.6843 15.375 14.1161 14.9433 14.1161 14.4107L14.1161 6.21429C14.1161 5.68173 13.6843 5.25 13.1518 5.25ZM13.1518 18.7494C13.6843 18.7494 14.1161 18.3176 14.1161 17.7851C14.1161 17.2525 13.6843 16.8208 13.1518 16.8208C12.6192 16.8208 12.1875 17.2525 12.1875 17.7851C12.1875 18.3176 12.6192 18.7494 13.1518 18.7494Z"
                            fill="#F3F3F3"
                        />
                    </G>
                </Svg>
            ),
            label: "Payment Failed !!",
            description: "Your Payment has Failed. Please try again.",
        },
        [PAYMENT_STATUS_CODE.success]: {
            bgColor: "#F7F7F7",
            icon: () => (
                <ImageView
                    source={Images.orderSuccess}
                    style={{
                        width: wp(24),
                        height: wp(24),
                    }}
                />
            ),
            label: "Your order is confirmed",
            description: "",
        },
    };

    const userId = useSelector((state) => state.AuthReducer.userId);

    const dispatch = useDispatch();

    const deliveryAddress = orderDetails?.address || {};
    const paymentAddress = orderDetails?.paymentAddress || {};

    useEffect(() => {
        if (orderId) {
            setLoading(true);
            dispatch(getOrderDetails({ orderId: orderId }))
                .then((res) => {
                    setLoading(false);
                    if ([200].includes(res?.payload?.status)) {
                        setOrderDetails(res?.payload?.data);
                        if (res?.payload?.data?.products && Array.isArray(res?.payload?.data?.products)) {
                            setOrderProductList(res?.payload?.data?.products);
                        }
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    alert("Error");
                    console.log("err", err);
                });
        }
    }, [orderId]);

    const renderItem = ({ item }) => {
        return (
            <OrderStatusCard
                gender={gender}
                productDetails={item}
                preorder={{
                    showPreorder: item?.isPreorder,
                    preorderDeliveryMessage: item?.preorderDeliveryMessage,
                }}
                inStore={false}
                isPaymentSuccess={orderDetails?.paymentStatus === PAYMENT_STATUS_CODE.success}
            />
        );
    };

    return (
        <ParentScrollView>
            <View style={Styles.container}>
                {loading && <ActivityIndicator size="large" color={Colors.black} />}
                {!loading && (
                    <>
                        <View style={[Styles.paymentContainer]}>
                            <View
                                style={[
                                    {
                                        flexDirection: "row",
                                        width:
                                            orderDetails?.paymentStatus === PAYMENT_STATUS_CODE.failed ? "60%" : "100%",
                                    },
                                    {
                                        alignItems:
                                            ORDER_STATUS_MAP[orderDetails?.paymentStatus]?.description?.length == 0
                                                ? "center"
                                                : "flex-start",
                                    },
                                ]}
                            >
                                {ORDER_STATUS_MAP[orderDetails?.paymentStatus]?.icon()}
                                <View style={[Styles.paymentPendingRightView]}>
                                    <VText style={[Styles.boldWhiteText]}>
                                        {ORDER_STATUS_MAP[orderDetails?.paymentStatus]?.label}
                                    </VText>
                                    {ORDER_STATUS_MAP[orderDetails?.paymentStatus]?.description?.length > 0 && (
                                        <VText
                                            style={[
                                                Styles.greyText,
                                                {
                                                    color: Colors.grey66,
                                                    fontSize: fp(14),
                                                    marginTop: spV(4),
                                                },
                                            ]}
                                        >
                                            {ORDER_STATUS_MAP[orderDetails?.paymentStatus]?.description}
                                        </VText>
                                    )}
                                </View>
                            </View>
                        </View>

                        <View style={Styles.addressContainer}>
                            <VText
                                style={[
                                    Styles.greyText,
                                    {
                                        fontSize: fp(16),
                                        color: "#333333",
                                    },
                                ]}
                            >
                                {"Delivery Address : "}
                                <VText
                                    style={[
                                        {
                                            fontWeight: "550",
                                        },
                                    ]}
                                >
                                    {deliveryAddress?.name}
                                </VText>
                            </VText>
                            <VText
                                style={[
                                    Styles.boldBlackText,
                                    {
                                        fontSize: fp(16),
                                        color: "rgba(33, 36, 39, 0.6)",
                                        fontWeight: "350",
                                        marginTop: 5,
                                    },
                                ]}
                            >
                                {deliveryAddress?.type}
                            </VText>

                            <VText style={Styles.addressText}>
                                {`${deliveryAddress?.addressLine1} ${deliveryAddress?.addressLine2} ${deliveryAddress?.city}, ${deliveryAddress?.state} ${deliveryAddress?.pincode}`}
                            </VText>
                        </View>
                        <View style={Styles.addressContainer}>
                            <VText
                                style={[
                                    Styles.greyText,
                                    {
                                        fontSize: fp(16),
                                        color: "#333333",
                                    },
                                ]}
                            >
                                {"Billing Address : "}
                                <VText
                                    style={[
                                        {
                                            fontWeight: "550",
                                        },
                                    ]}
                                >
                                    {paymentAddress?.name}
                                </VText>
                            </VText>
                            <VText
                                style={[
                                    Styles.boldBlackText,
                                    {
                                        fontSize: fp(16),
                                        color: "rgba(33, 36, 39, 0.6)",
                                        fontWeight: "350",
                                        marginTop: 5,
                                    },
                                ]}
                            >
                                {paymentAddress?.type}
                            </VText>

                            <VText style={Styles.addressText}>
                                {`${paymentAddress?.addressLine1} ${paymentAddress?.addressLine2} ${paymentAddress?.city}, ${paymentAddress?.state} ${paymentAddress?.pincode}`}
                            </VText>
                        </View>
                        <ListView
                            contentContainerStyle={{ marginTop: spV(16) }}
                            data={orderProductList}
                            renderItem={renderItem}
                            keyExtractor={(item) => Math.random().toString()}
                        />
                    </>
                )}
            </View>
        </ParentScrollView>
    );
};

export default OrderStatus;

export const Styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingLeft: spH(200),
        paddingTop: spV(28),
        width: wp(700),
        minHeight: hp(500),
    },
    boldWhiteText: {
        fontSize: fp(20),
        fontWeight: "400",
    },
    boldBlackText: {
        color: Colors.black,
        fontWeight: "550",
        fontSize: FONTS_SIZES.s14,
    },
    addressText: {
        width: "85%",
        fontWeight: "350",
        fontSize: fp(16),
        color: "rgba(33, 36, 39, 0.6)",
        marginTop: 5,
    },
    greyText: {
        fontWeight: "350",
        color: Colors.greyText,
    },
    addressContainer: {
        backgroundColor: "white",
        paddingTop: spV(16),
    },
    paymentContainer: {
        minHeigh: spV(50),
        padding: 16,
        flexDirection: "row",
        marginVertical: spV(7),
        alignItems: "center",
        justifyContent: "space-between",
        paddingLeft: 0,
    },
    paymentPendingRightView: {
        paddingLeft: 10,
        flexGrow: 1,
        flex: 1,
    },
    img: {
        height: 30,
        width: 30,
    },
});
